import type { CampaignDetailsCreator } from '../types/campaign.types'
import type { TrafficSourceCosts } from '../types/traffic-source-costs.types'

export const getEffectiveCreatorClickLimit = (
  creator: CampaignDetailsCreator,
  campaignMaxClicks?: number,
): number | null => creator.overrides.clickLimit || campaignMaxClicks || null

export const isCreatorClickLimitOverrideRemoved = (creator: CampaignDetailsCreator): boolean =>
  creator.overrides.clickLimit === 0

export const getEffectiveCreatorTrafficSourceCosts = (
  creator: CampaignDetailsCreator,
  campaignTrafficSourceCosts?: TrafficSourceCosts[],
): TrafficSourceCosts[] => {
  if (creator.overrides?.trafficSourcesCosts?.length) {
    return creator.overrides.trafficSourcesCosts
  }
  if (campaignTrafficSourceCosts?.length) {
    return campaignTrafficSourceCosts
  }
  return []
}
